module.exports = __webpack_public_path__ + "img/T3.7c6d6376.png";